import cn from 'classnames';
import React from 'react';

import styles from './logobox.module.scss';

interface ILogoProps {
  imgUrl: string;
  className?: string;
}

export const Logo: React.FC<ILogoProps> = React.memo(({ className, imgUrl }) => (
  <div className={cn(className, styles.item)}>
    <img src={imgUrl} />
  </div>
));
